export const tableStyles = {
  "& td, & th": {
    borderRight: "1px solid",
    borderRightColor: "divider",
  },
  "& td:last-of-type, & th:last-of-type": {
    borderRight: "none",
  },
};
